import { moduleProviderFactory } from "mrb/core";
import { CertifierDashboard } from "application/certifier/pages";
import { CertifierDashboardRouteStore } from "application/certifier/stores";

(function () {
    moduleProviderFactory.module("application").register({
        name: "application.certifier",
        routes: [
            {
                name: "master.application.certifier",
                pattern: "/certifier",
                children: [
                    {
                        name: "master.application.certifier.dashboard",
                        pattern: "",
                        component: CertifierDashboard,
                        store: CertifierDashboardRouteStore,
                        data: {
                            title: "APPLICATION.CERTIFIER.DASHBOARD.TITLE",
                        },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "APPLICATION.MENU.CERTIFIER",
                order: 2,
                authorization: ["$certifier$"],
                icon: "dashboard",
                route: "master.application.certifier.dashboard",
            },
        ],
    });
})();
